import { XMPPEvents } from 'lib-jitsi-meet/dist/esm/service/xmpp/XMPPEvents';

const Xmpp = {
    applyOverride(xmpp) {

        xmpp.createRoom = function(roomName, options) {
            const resource = Strophe.getResourceFromJid(this.connection.jid);
            const roomjid = `${roomName}@${this.options.hosts.muc}/${resource}`;

            return this.connection.emuc.createRoom(roomjid, null, options);
        };
        xmpp.myJid = function() {
            return (
                this.connection
                && this.connection.jid
                    ? this.connection.jid
                    : null);
        };
        xmpp.myResource = function() {
            return (
                this.connection
                && this.connection.jid
                    ? Strophe.getResourceFromJid(this.connection.jid)
                    : null);
        };
        xmpp.disconnect = function(ev) {
            if (ev && ev instanceof Object && ev.cancelable) {
                return Promise.resolve();
            }
            if (this.disconnectInProgress) {
                return this.disconnectInProgress;
            } else if (!this.connection || !this._startConnecting) {
                // we have created a connection, but never called connect we still want to resolve on calling disconnect
                // this is visitors use case when using http to send conference request.
                return Promise.resolve();
            }

            this.disconnectInProgress = new Promise(resolve => {
                const disconnectListener = (credentials, status) => {
                    if (status === Strophe.Status.DISCONNECTED) {
                        resolve();
                        this.eventEmitter.removeListener(XMPPEvents.CONNECTION_STATUS_CHANGED, disconnectListener);
                    }
                };

                this.eventEmitter.on(XMPPEvents.CONNECTION_STATUS_CHANGED, disconnectListener);
            });

            this._cleanupXmppConnection(ev);

            return this.disconnectInProgress;
        };
    }

};


export default Xmpp;
